// React and related imports
import React, { useCallback } from 'react';

// i18n translation
import { useTranslation } from 'react-i18next';

// Custom Components
import { PageHeader } from '../components/Shared/PageHeader';
import { ContentContextTable } from '../components/ContentContextTable/ContentContextTable';
import { ContentContextModal } from '../components/ContentContextModal/ContentContextModal';

// Redux slices
import {
  openContentContextModal,
  setSelectedContentContext,
} from '../redux/slices/contentContextSlice';

// Redux hooks
import { useAppDispatch } from '../redux/hooks/useAppDispatch';

// Interfaces
import { IContentContext } from '../common/interfaces/ContentContext.interface';
import { Status } from '../common/enums/Status';
import { PrayerName } from '../common/enums/PrayersName';
import { ContentContextTypes } from '../common/enums/ContentContextTypes';

// Hooks
import { usePageTitle } from '../hooks/usePageTitle';

export const ContentContextPage: React.FC = () => {
  const { t } = useTranslation();

  usePageTitle(t('pageTitles.contentContext'));

  const dispatch = useAppDispatch();

  // Initialize content context state
  const initialContextState: IContentContext = {
    title: [],
    description: [],
    status: Status.INACTIVE,
    prayerName: '' as PrayerName,
    time: '',
    adhanDelta: '',
    days: [],
    startDate: '',
    endDate: '',
    isForever: true,
    type: ContentContextTypes.GENERIC,
  };

  const handleAddClick = useCallback(() => {
    dispatch(setSelectedContentContext(initialContextState));
    dispatch(openContentContextModal({ isModalOpenedForAdd: true }));
  }, [dispatch, initialContextState]);

  return (
    <>
      <PageHeader
        title={t('contentContext.contentContextManagement')}
        buttonText={t('contentContext.addNewContext')}
        buttonOnClick={() => handleAddClick()}
      />
      <ContentContextTable />
      <ContentContextModal />
    </>
  );
};
